module.exports = __webpack_public_path__ + "img/stackslash-35.f68e2513.jpg";